export default __webpack_public_path__ + "static/social-sharing-022285b115a1e060b891581be3b7630a.png";